import { FieldValues } from 'react-hook-form'

import { FieldConfig } from '../filter.types'

export type FieldBlock<T extends FieldValues> = {
  section: string | null
  fields: FieldConfig<T>[]
}

export function buildFieldBlocks<T extends FieldValues>(fields: FieldConfig<T>[]): FieldBlock<T>[] {
  const blocks: FieldBlock<T>[] = []

  for (const field of fields) {
    const section = field.section ?? null
    const last = blocks[blocks.length - 1]
    if (last && last.section === section) {
      last.fields.push(field)
    } else {
      blocks.push({ section, fields: [field] })
    }
  }

  // Flatten sections with ≤2 visible fields (grouped fields count as one)
  return blocks.map((block) => {
    if (block.section === null) return block
    const uniqueCount = new Set(block.fields.map((f) => f.group ?? f.name)).size
    if (uniqueCount <= 2) return { ...block, section: null }

    return block
  })
}
